var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.0374 0 0 4.0374 0 9C0 13.9626 4.0374 18 9 18C13.9626 18 18 13.9626 18 9C18 4.0374 13.9626 0 9 0ZM16.1379 8.1H9.9V3.6V1.8621C13.1499 2.2698 15.7302 4.8501 16.1379 8.1ZM1.8 9C1.8 5.3352 4.5549 2.3076 8.1 1.8621V3.6V9C8.1 9.1071 8.1252 9.2106 8.1621 9.3105C8.1738 9.3393 8.1855 9.3663 8.1999 9.3942C8.2134 9.4212 8.2197 9.4509 8.2368 9.4779L12.0186 15.5286C11.0988 15.9552 10.0782 16.2 9 16.2C5.0301 16.2 1.8 12.9699 1.8 9ZM13.5468 14.5764L10.6245 9.9H16.1379C15.9021 11.7783 14.9445 13.4352 13.5468 14.5764Z",
  fill: "#C4C7C5"
});

function SvgMarkets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.c88300cacfbd051aabd272797adec4c7.svg";
export { ForwardRef as ReactComponent };